<template>
  <div class="page-container">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  components: {
  },
}
</script>

<style scoped>
.page-container {
  padding-top: 70px; /* 为固定导航栏预留空间 */
}
</style>

<style>
.el-timeline-item__timestamp{
  font-size: 0.9rem !important;
  padding: 1rem 0;
}
</style>
